// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/audio-lines.js';

import { paths } from '../generated/audio-lines';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('audio-lines', Original, paths);
